module.exports = __webpack_public_path__ + "static/img/htp.fbcba13b.png";